"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../../core/model/DomainObject");

var CompetitorProduct_1 = require("../../../product/model/CompetitorProduct");

var Competitor_1 = require("../../../site/model/Competitor");

var CompetitorSite_1 = require("../../../site/model/CompetitorSite");

var CompetitorPrice_1 = require("../CompetitorPrice");

var SimpleZonePrice_1 = require("../SimpleZonePrice");
/**
 * Data transfer object describing external product on data-pairing pages
 *
 * @author RV
 */


var CompetitorProductDTO =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(CompetitorProductDTO, _DomainObject_1$Domai);

  /**
   *
   * @param ratio from {@link CompetitorProductBinding}
   * @param charger from {@link CompetitorProductBinding}
   * @param competitorReferencePrices list of values of competitor reference prices
   * @param modifiedPrices list of competitor reference prices modified by size ratio and size charger
   * @param researchType the type of agency research, only for unpaired product
   * @param competitorPrice the price from agency research, only for unpaired product
   * @param competitorProduct
   * @param competitorSite
   * @param competitor
   */
  function CompetitorProductDTO(ratio, charger, modifiedPrices, competitorReferencePrices, researchType, competitorPrice, competitorProduct, competitorSite, competitor) {
    var _this;

    _classCallCheck(this, CompetitorProductDTO);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CompetitorProductDTO).call(this));
    _this.ratio = ratio;
    _this.charger = charger;
    _this.modifiedPrices = modifiedPrices;
    _this.competitorReferencePrices = competitorReferencePrices;
    _this.researchType = researchType;
    _this.competitorPrice = competitorPrice;
    _this.competitorProduct = competitorProduct;
    _this.competitorSite = competitorSite;
    _this.competitor = competitor;
    return _this;
  }

  return CompetitorProductDTO;
}(DomainObject_1.DomainObject);

exports.CompetitorProductDTO = CompetitorProductDTO; // tslint:disable-next-line:member-ordering

CompetitorProductDTO.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(CompetitorProductDTO.name);
  return {
    ratio: builder.bigNum('ratio'),
    charger: builder.bigNum('charger'),
    modifiedPrices: builder.listOf(builder.obj('modifiedPrices', SimpleZonePrice_1.SimpleZonePrice.schema, function (mat) {
      return new SimpleZonePrice_1.SimpleZonePrice(mat.zoneId, mat.price);
    })),
    competitorReferencePrices: builder.listOf(builder.obj('competitorReferencePrices', SimpleZonePrice_1.SimpleZonePrice.schema, function (mat) {
      return new SimpleZonePrice_1.SimpleZonePrice(mat.zoneId, mat.price);
    })),
    researchType: builder.opt(builder.str('researchType')),
    competitorPrice: builder.opt(builder.obj(CompetitorPrice_1.CompetitorPrice.name, CompetitorPrice_1.CompetitorPrice.schema, function (mat) {
      return new CompetitorPrice_1.CompetitorPrice(mat.id, mat.dataUploadId, mat.date, mat.flags, mat.competitorProductId, mat.siteId, mat.value, mat.regularPrice, mat.city, mat.isFromWebScraping, mat.promo, mat.sellout);
    })),
    competitorProduct: builder.obj(CompetitorProduct_1.CompetitorProduct.name, CompetitorProduct_1.CompetitorProduct.schema, function (mat) {
      return new CompetitorProduct_1.CompetitorProduct(mat.id, mat.eans, mat.name, mat.productSize, mat.productSizeUnit, mat.category, mat.productContent, mat.productSpecification, mat.suppliers, mat.ignored, mat.competitorId, mat.competitorExternalId, mat.externalId, mat.specialId, mat.available, mat.comment, mat.compoundId, mat.internalCategoryIds);
    }),
    competitorSite: builder.opt(builder.obj(CompetitorSite_1.CompetitorSite.name, CompetitorSite_1.CompetitorSite.schema, function (mat) {
      return new CompetitorSite_1.CompetitorSite(mat.id, mat.externalId, mat.address, mat.city, mat.companyId, mat.type, mat.formatId, mat.active);
    })),
    competitor: builder.obj(Competitor_1.Competitor.name, Competitor_1.Competitor.schema, function (mat) {
      return new Competitor_1.Competitor(mat.id, mat.externalId, mat.name);
    })
  };
}();